export const ROLES = {
    SHEDULER: 'SCHEDULER',
    ADMIN: 'ADMIN',
    OPS_TEAM: 'OPS_TEAM',
    STAKE_HOLDERS: 'STAKEHOLDERS',
    PROVIDER: 'RAD',
    TENANT_ADMIN: 'TENANT_ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
}
